import { isValidHexColor, normalizeHexColor } from './utils';

/** Splash / screen bottom anchor (dark navy), not the saturated brand hex. */
const DARK_BASE = '#010621';

const rgbTuple = (hex) => {
  const n = isValidHexColor(hex) ? normalizeHexColor(hex) : DARK_BASE;
  const h = n.slice(1);
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
};

const toHex = ([r, g, b]) =>
  `#${[r, g, b]
    .map((x) => Math.max(0, Math.min(255, x)).toString(16).padStart(2, '0'))
    .join('')}`;

/** Linear RGB blend: t=0 → a, t=1 → b */
const mixHex = (hexA, hexB, t) => {
  const u = Math.max(0, Math.min(1, t));
  const a = rgbTuple(hexA);
  const b = rgbTuple(hexB);
  const out = a.map((v, i) => Math.round(v * (1 - u) + b[i] * u));
  return toHex(out);
};

const solid = (hex) => (isValidHexColor(hex) ? normalizeHexColor(hex) : DARK_BASE);

/**
 * Preview gradients: light tint of the brand color at the top, transitioning into
 * dark navy (#010621) — not transparent-to-brand (which reads as pale grey → vivid
 * color on a light canvas, unlike the product splash).
 */
export const getScreenPreviewGradient = (key, baseHex) => {
  const brand = solid(baseHex);
  const dark = DARK_BASE;
  const top = mixHex(brand, '#ffffff', 0.46);
  const mid = mixHex(brand, dark, 0.42);

  switch (String(key)) {
    case '2':
      return `linear-gradient(192.04deg, ${top} 0%, ${mid} 48%, ${dark} 100%)`;
    case '3':
      return `linear-gradient(180deg, ${top} 0%, ${mid} 36%, ${dark} 78%, ${dark} 100%)`;
    case '1':
    default:
      return `linear-gradient(135deg, ${top} 0%, ${mid} 40%, ${dark} 78%, ${dark} 100%)`;
  }
};
